<template>
  <!-- 'is-inputed': curValue?true:false, 'is-has-hover': isHasHover && !curValue-->
  <div class="input-box-wrapper"
  :class="{'is-right': isRight, 'is-error': isError ,'is-has-hover': isHasHover}">
    <!-- 输入项 -->
    <div class="input-box-content">
      <!-- 是否正确 -->
      <i class="status"></i>

      <!-- 1 2 3 4 ... -->
      <div class="serial-number">
        {{ curIndex + 1 }}
      </div>
      <!-- 输入框 -->
      <div v-if="isInputOrMsg" class="content input-content">
        <!-- 公式编辑器 -->
        <div
          :id="`answer${curIndex+1}`"
          v-if="inputType == 1 && !isArt"
          class="math-edit-input"
        ></div>
        <!-- 普通输入框 -->
        <input v-else
        v-model.trim="curValue"
        @input="fillInput(curIndex,$event)" type="text" :placeholder="defaultPlaceholder">
      </div>
      <!--<div v-else  class="input-msg row-scroll">-->
        <!--<p v-if="!inputType" v-katex="formatChar(content)"></p>-->
        <!--<p v-else v-html="content"></p>-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>
// import { htmlDecodeByRegExp } from '@/utils'
// api引用
/* eslint-disable */

export default {
  name: 'InputBox',
  data() {
    return {
      editorObjs: {}, // 编辑器
      defaultPlaceholder: '请输入答案',
      curValue: '',
    };
  },
  props: {
    content: {
      type: String,
      default: '',
    },
    curIndex: {
      type: Number,
      default: 0,
    },
    inputType: { // 1公式输入框  0普通输入框
      type: Number,
      default: null,
    },
    isRight: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    isInputOrMsg: {
      type: Boolean,
      default: false,
    },
    isHasHover: {
      type: Boolean,
      default: false,
    },
    isArt: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    content(newVal, oldVal) {
      this.curValue = newVal;
    },
  },
  computed: {
    // inputType(v){
    //   console.log('填空题类型===',v)
    // }
  },
  mounted() {
    console.log(this.isArt);
    this.initData();
  },
  methods: {
    formatChar(val) {
      const realVal = val.replace(/</g, '< ');
      return realVal !== '' ? `$${realVal}$` : realVal;
    },
    fillInput(index, e, inputType) {
      this.$emit('fillInput', {
        index,
        content: this.curValue,
      }, e);
    },
    blurEditor(index, e) {
      this.editorObjs.mathEditor.hide();
    },
    checkCanSubmit() {
      const inputValue = this.editorObjs ? this.editorObjs.mathEditor.getValue() : '';
      this.curValue = inputValue;
      this.$emit('fillInput', {
        index: this.curIndex,
        content: this.curValue,
      });
    },
    initData() {
      if (this.inputType === 1 && this.isInputOrMsg && !this.isArt) {
        console.log('InputBox组件 initMathEditor  --------->', this.curIndex);
        setTimeout(() => {
          this.initMathEditor(this.curIndex);
        }, 300);
      }
    },
    initMathEditor(index) {
      const { subject_id, stage } = { subject_id: sessionStorage.getItem('dl-subjectId'), stage: sessionStorage.getItem('dl-stage') };
      // const _this = this
      this.editorObjs = {
        mathEditor: null,
        isBack: true,
        backTimes: 0,
        oldValue: '',
        inputType: '',
      };
      const addButtons = new Formular({ subjectId: subject_id, stage });
      const id = `answer${index + 1}`;
      this.editorObjs.mathEditor = new window.MtEditor({
        id,
        tabs: [],
        theme: 'blue',
        btns: addButtons,
      }, (() => {
      }));
    },
  },

  beforeDestroy() {
    if (this.editorObjs.mathEditor) {
      this.editorObjs.mathEditor.destroy();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.math-edit-input {
  height: 100%;
  width: 100%;
  min-width: 100% !important;
  max-width: 100% !important;
  min-height: 100% !important;
  /*border: 1px solid #ccc;*/
  /*padding: 5px 0 !important;*/
  padding: 5px 0 5px 5px !important;
  box-sizing: border-box;
  overflow: auto;
  display: flex;
}
.math-edit-input textarea{
  width: 0;
  height: 0;
  border: none;
}
.matheditor-btn-span {
  width: 50px;
  height: 50px;
}
.input-box-wrapper {
  width: 100%;
  border-radius:6px;
  border: 1px solid rgba(255, 255, 255 ,0);
  padding: 5px;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  .input-box-content {
    width: 100%;
    min-height: 42px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size:16px;
    line-height:28px;
    background:rgba(255,255,255,1);
    border-radius:6px;
    border:2px solid rgba(222,230,238,1);
    padding: 6px 6px 6px 42px;
    box-sizing: border-box;
    position: relative;
    .serial-number {
      height: 22px;
      width: 22px;
      line-height: 22px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(255,255,255,1);
      text-align: center;
      border-radius: 11px;
      background:rgba(222,230,238,1);
      margin: 0 6px 0 14px;
      // padding: 0 7px 0 23px;
      position: absolute;
      top: 11px;
      left: 0;
    }
    .content {
      display: inline-block;
      color:rgba(36,60,84,1);
      width: 100%;
      min-height: 34px;
      text-align: left;
      font-family: PingFangSC-Regular, PingFang SC;
      word-break: break-word;
      box-sizing: border-box;
      input {
        color:rgba(36,60,84,1);
        display: block;
        width: 100%;
        min-height: 34px;
        // line-height: 36px;
        font-size: 16px;
        border: none;
        outline: none;
        &::-webkit-input-placeholder{  /* 使用webkit内核的浏览器 */
          font-weight:400;
          padding-left: 5px;
          color:rgba(181,197,213,1);
          line-height:22px;
        }
        &:-moz-placeholder{  /* Firefox版本4-18 */
          font-weight:400;
          color:rgba(181,197,213,1);
          padding-left: 5px;
          line-height:22px;
        }
        &::-moz-placeholder{  /* Firefox版本19+ */
          font-weight:400;
          color:rgba(181,197,213,1);
          padding-left: 5px;
          line-height:22px;
        }
        &:-ms-input-placeholder{  /* IE浏览器 */
          font-weight:400;
          padding-left: 8px;
          color:rgba(181,197,213,1);
          line-height:22px;
        }
      }
    }
    .input-msg {
      min-height: 34px;
      // line-height: 36px;
      overflow: auto;
      margin-right: 58px;
    }
    .images-wrapper {
      .images-item {
        width: 100%;
        margin-bottom: 5px;
        img {
          max-width: 80%;
          display: inline-block;
        }
      }
    }
  }
  .angle {
    display: inline-block;
    width: 22px;
    height: 22px;
    position: absolute;
    z-index: 99;
    background-size: contain;
    background-image: url('./images/default_angle.png');
    background-repeat: no-repeat;
  }
  &.is-has-hover:hover {
    .input-box-content {
      background:rgba(255,255,255,1);
      border:2px solid rgba(144,185,217,1);
    }
    .angle {
      background-image: url('./images/hover_angle.png');
    }
  }
  .left-top {
    top: -4px;
    left: -4px;
  }
  .right-top {
    top: -4px;
    right: -4px;
    transform: rotate(90deg);
  }
  .left-bottom {
    bottom: -4px;
    left: -4px;
    transform: rotate(-90deg);
  }
  .right-bottom {
    bottom: -4px;
    right: -4px;
    transform: rotate(180deg);
  }
  &.is-inputed, &.is-inputed:hover {
    background:rgba(207,255,253,1);
    border-radius: 10px;
    border:1px solid rgba(95,208,255,0.3);
    .input-box-content {
      background:linear-gradient(180deg,rgba(205,250,255,1) 0%,rgba(235,253,255,1) 5%,rgba(255,255,255,1) 10%,rgba(255,255,255,1) 90%,rgba(235,253,255,1) 95%,rgba(205,250,255,1) 100%);
      border:2px solid rgba(0,178,255,1);
      .serial-number {
        background:rgba(0,178,255,1);
      }
      .content {
        color:rgba(40,58,90,1);
        input {
          color:rgba(40,58,90,1);
        }
      }
    }
    .angle {
      background-image: url('./images/choosed_angle.png');
    }
  }
  &.is-right, &.is-error {
    .status {
      display: inline-block;
      width: 58px;
      height: 42px;
      background-size: contain;
      position: absolute;
      right: -2px;
      top: -1px;
      z-index: 100;
    }
  }
  &.is-right, &.is-right.is-inputed {
    background:rgba(212,255,235,1);
    border-radius: 10px;
    border:1px solid rgba(21,222,131,0.3);
    .input-box-content {
      background:linear-gradient(180deg,rgba(210,255,235,1) 0%,rgba(235,253,255,1) 5%,rgba(255,255,255,1) 10%,rgba(255,255,255,1) 90%,rgba(235,253,255,1) 95%,rgba(210,255,235,1) 100%);
      border:2px solid rgba(21,222,131,1);
      .serial-number {
        background:rgba(21,222,131,1);
      }
      .content {
        color:rgba(21,222,131,1);
        input {
          color:rgba(21,222,131,1);
        }
      }
      .status {
        background-image: url('./images/chiose_right.png');
      }
    }
    .angle {
      background-image: url('./images/right_angle.png');
    }
  }
  &.is-error, &.is-error.is-inputed {
    background:rgba(255,213,220,1);
    border-radius: 10px;
    border:1px solid rgba(255,80,111,0.3);
    .input-box-content {
      background:linear-gradient(180deg,rgba(255,239,243,1) 0%,rgba(255,250,253,1) 5%,rgba(255,255,255,1) 10%,rgba(255,255,255,1) 90%,rgba(255,250,253,1) 95%,rgba(255,239,243,1) 100%);
      border:2px solid rgba(255,80,111,1);
      .serial-number {
        background:rgba(255,80,111,1);
      }
      .content {
        color:rgba(255,80,111,1);
        input {
          color:rgba(255,80,111,1);
        }
      }
      .status {
        background-image: url('./images/chiose_error.png');
      }
    }
    .angle {
      background-image: url('./images/error_angle.png');
    }
  }
}
</style>

<style lang="scss">
.input-box-wrapper {
  div[class^="matheditor-wrapper-"] .mq-editable-field {
    border: none !important;
  }
  div[class^="matheditor-toolbar-"]{
    margin-top: 60px !important;
  }
  .input-box-content {
    .katex {
      margin-bottom: 0;
    }
  }
}
</style>
